<app-search></app-search>

<div class="row">
  <div class="col-md-12">
    <app-generic-inline *ngIf="meta" [meta]="meta" [loading]="loading" hasPermission="true"
                    [items]="items"></app-generic-inline>
  </div>
</div>
<div class="row" style="margin:10px 0px;">
  <div class="col-md-12">
    <div class="panel panel-default" style="border: none;">
      <div class="panel panel-default" style="margin-top:10px;">
        <div class="panel-heading">
          <h4 class="panel-title">
            Advisory Reports
          </h4>
        </div>
        <div class="panel-body">
          <div class="row" style="margin:10px 0px">
            <div class="col-md-12 table-responsive">
              <table class="table table-striped">
                <thead>
                <tr>
                  <th>Start Date</th>
                  <th>End Date</th>
                  <th>Advisories</th>
                  <th></th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let advisory of advisory_ranges?.slice((currentPage-1)*10)">
                  <td>{{ advisory.actual_startdate | date:'fullDate' }}</td>
                  <td>{{ advisory.actual_stopdate | date:'fullDate' }}</td>
                  <td>{{ advisory.total }}</td>
                  <td style="max-width:150px;">
                    <a target="_blank"
                       href="{{baseUrl}}/beaches/advisoryactivity/report/?actual_startdate={{ advisory.actual_startdate }}&actual_stopdate={{ advisory.actual_stopdate }}">
                      <button class="btn-primary">Get Report</button>
                    </a>
                    <a target="_blank" *ngIf="advisory.exists"
                       href="{{baseUrl}}/beaches/advisoryactivity/report/?actual_startdate={{ advisory.actual_startdate }}&actual_stopdate={{ advisory.actual_stopdate }}&force=true">
                      <button class="btn-primary">Re-generate Report</button>
                    </a>
                    <button class="btn-primary" *ngIf="advisory.exists" (click)="open_email_modal(advisory)">Email
                      List
                    </button>
                  </td>
                </tr>
                </tbody>
              </table>
              <!-- todo: add pagniation to reports list -->
<!--              <div class="text-center">-->
<!--                <ngb-pagination boundaryLinks="false" [collectionSize]="advisory_ranges?.length" [(ngModel)]="currentPage"-->
<!--                                [maxSize]="5" [pageSize]="25" class="pagination"></ngb-pagination>-->
<!--              </div>-->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
